export const colorForPatientRisk = (colors, patientRisk) => {
  return colors.colorFor(patientRisk.color);
};

export const isDarkPatientRisk = (colors, patientRisk) => {
  return colors.colorText(patientRisk.color) === colors.brightText;
};
